// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "subscriptions-2o5_m";
export { _1 as "__esModule", _2 as "mobile", _3 as "subscriptions" }
export default { "__esModule": _1, "mobile": _2, "subscriptions": _3 }
